import React from "react";

export const feedFilterTypes = [
  {
    label: "All",
    key: "all",
  },
  {
    label: "Company",
    key: "company",
  },
  {
    label: "My Location",
    key: "location",
  },
  {
    label: "Recognition",
    key: "recognition",
  },
  {
    label: "Polls",
    key: "polls",
  },
  {
    label: "For you",
    key: "for_you",
  },
];

export const feedLimitedFilterTypes = [
  {
    label: "My Location",
    key: "location",
  },
  {
    label: "Recognition",
    key: "recognition",
  },
  {
    label: "Polls",
    key: "polls",
  },
  {
    label: "For you",
    key: "for_you",
  },
];

export const feedTypes = [
  "company update",
  "priority",
  "news",
  "announcement",
  "kudos",
  "poll",
  // 'question',
  // 'incident reporting',
  // 'meeting',
  // 'task checklist',
  // 'polls/pulse survey',
];

export const managerFeedTypes = [
  "priority",
  "news",
  "announcement",
  "kudos",
  "poll",
];

export const employeeFeedTypes = ["news", "announcement", "kudos", "poll"];

export const feedKudosTypes = [
  {
    label: "Congratulations",
    key: "congratulations",
  },
  {
    label: "You're a star",
    key: "star",
  },
  {
    label: "Thank you",
    key: "thank_you",
  },
  {
    label: "Work Anniversary",
    key: "work_anniversary",
  },
  {
    label: "Happy Birthday",
    key: "happy_birthday",
  },
];

export const feedToAdminTypes = ["company", "location", "employee", "team"];

export const feedToTypes = ["location", "employee", "team"];

export const feedStringKeys = [
  "target",
  "title",
  "description",
  "feed_type",
  "kudos_type",
  "is_acknowledgement_required",
  "is_comment_disabled",
  "is_reaction_disabled",
];

export const reactionTypes = ["like"];

export const reactionIcons = {
  like: "👍",
};

export const feedPollTypes = ["text", "image"];

export const formatFeedVotes = (votes) => {
  // Handle empty array, null, or undefined
  if (!votes || !Array.isArray(votes) || votes.length === 0) {
    return [];
  }

  const formattedVotes = votes.map((vote) => {
    const votedEmployees = vote.voted_employees || [];

    return {
      ...vote,
      display_list: votedEmployees.slice(0, 5),
      all_list: votedEmployees,
    };
  });

  return formattedVotes;
};
